// POS-I187: the landing page picks Pakistan or other-country wording without sending the visitor's
// address to a third party. The browser's own time zone is enough for a default; the country
// selector (stored override) still wins.

const BY_ZONE: Record<string, string> = {
  'Asia/Karachi': 'PK',
  'Asia/Dubai': 'AE',
  'Asia/Muscat': 'AE',
  'Asia/Riyadh': 'SA',
  'Europe/London': 'GB',
  'Asia/Kolkata': 'IN',
  'Asia/Calcutta': 'IN',
  'Asia/Dhaka': 'BD',
};

/** Country code for an IANA time zone: PK for an unknown or missing zone (the default audience). */
export function countryFromTimeZone(timeZone: string | undefined | null): string {
  if (!timeZone) return 'PK';
  if (BY_ZONE[timeZone]) return BY_ZONE[timeZone];
  if (timeZone.startsWith('America/')) return 'US';
  if (timeZone.startsWith('Europe/') || timeZone.startsWith('Asia/') || timeZone.startsWith('Africa/') ||
      timeZone.startsWith('Australia/') || timeZone.startsWith('Pacific/') || timeZone.startsWith('Atlantic/') ||
      timeZone.startsWith('Indian/')) return 'Other';
  return 'PK';
}

export function browserTimeZone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
}
